// @flow

export function removeNulls<T: {[name: string]: any}>(input: T): T {
  return Object.keys(input).reduce((output, key) => {
    if (input[key] !== null && input[key] !== undefined) {
      output[key] = input[key];
    }
    return output;
  }, ({}: any));
}
